export enum DealType {
  Lease = 'Lease',
  Finance = 'Finance',
  Cash = 'Cash',
}
